export default {
  title: 'Rewards',
  guest: {
    eyebrow: 'Rewards',
    headline: 'Every order earns you <highlight>rewards</highlight>',
    subheading_one: 'Earn {{count}} point per {{amount}} spent.',
    subheading_other: 'Earn {{count}} points per {{amount}} spent.',
    cta: 'Sign up & start earning',
    already_member: 'Already a member?',
    sign_in: 'Sign in',
    redeemable_heading: 'Your points = free food',
    redeemable_eyebrow: '🎁 Rewards you’ll unlock',
  },
  member: {
    balance_label: 'Your balance',
    balance_suffix: 'points · worth <highlight>{{amount}}</highlight>',
    next_reward: 'Next reward at <highlight>{{points}} pts</highlight>',
    redeem_hint: '✓ You can redeem up to {{points}} pts ({{amount}}) on your next order',
    expiration_zero: '⏳ {{points}} pts expire today',
    expiration_one: '⏳ {{points}} pts expire in 1 day',
    expiration_other: '⏳ {{points}} pts expire in {{count}} days',
    pts_lifetime: 'Pts lifetime',
    saved_lifetime: 'Saved lifetime',
    cta: 'Order now',
    redeemable_heading: 'What you can redeem',
    redeemable_eyebrow: 'You have {{points}} pts ({{amount}})',
    redeemable_description:
      'Up to {{maxPoints}} pts ({{maxAmount}}) per order. Items under {{maxAmount}} are completely free.',
  },
  items: {
    free: 'FREE',
    save: 'Save {{amount}}',
  },
  history: {
    eyebrow: 'History',
    title: 'Recent activity',
    load_more: 'Load more',
    sources: {
      welcome_bonus: 'Welcome bonus',
      google_review_reward: 'Google review reward',
      reward_loyalty_program_conversion: 'Loyalty program conversion',
      cashback: 'Cashback earned',
      refund: 'Order refunded',
      cashback_usage: 'Points redeemed',
      cashback_usage_refund: 'Redemption refunded',
      expired_points_void: 'Points expired',
      mobile_app_signup_bonus: 'Mobile app signup bonus',
    },
    detail_with_order: 'Order #{{number}} · {{amount}}',
  },
  how_it_works: {
    eyebrow_guest: 'Simple & Automatic',
    eyebrow_member: 'Quick reminder',
    title: 'How it works',
    steps: {
      sign_up: {
        emoji: '📲',
        title: 'Sign up free',
        desc: 'Create an account in 30 seconds.',
      },
      order: {
        emoji: '🍔',
        title: 'Order & earn',
        desc_one: '1 pt per {{amount}} — auto-tracked.',
        desc_other: '{{count}} pts per {{amount}} — auto-tracked.',
      },
      build: {
        emoji: '⭐',
        title: 'Build points',
        desc: 'Redeem from {{minPoints}} pts. Valid {{lifetime}} days.',
      },
      save: {
        emoji: '🎁',
        title: 'Save at checkout',
        desc: 'Up to {{maxAmount}} off — applied instantly.',
      },
      repeat: {
        emoji: '🔄',
        title: 'Repeat & save',
        desc: 'Every order grows your balance.',
      },
    },
  },
  faq: {
    eyebrow: 'Questions?',
    title: 'Frequently asked',
    items: {
      earn: {
        q: 'How do I earn points?',
        a_one:
          'You earn 1 point for every {{amount}} you spend. Points are added automatically to your account after each order — no scanning or codes needed.',
        a_other:
          'You earn {{count}} points for every {{amount}} you spend. Points are added automatically to your account after each order — no scanning or codes needed.',
      },
      redeem: {
        q: 'When can I start redeeming?',
        a: 'You can start redeeming once you reach {{minPoints}} points. Use them at checkout to reduce your order total.',
      },
      max: {
        q: 'How much can I save per order?',
        a: 'You can redeem up to {{maxPoints}} points ({{maxAmount}}) per order. That’s the maximum discount you can apply in a single checkout.',
      },
      validity: {
        q: 'How long are points valid?',
        a: 'Points are valid for {{lifetime}} days from when they’re earned. Use them before they expire!',
      },
    },
  },
};
